export const URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gm;

export const LETTER_REGEX = new RegExp(/^[A-Za-z\s]*$/);

export const DOMAIN_REGEX = /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i;

export const EMAIL_REGEX = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;

export const DOMAIN_SECONDARY_REGEX =
  /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/;

export const NUMBERS_ONLY_REGEX = /^[0-9]*$/;

export const CLAY_WEBHOOKS_URL_REGEX =
  /^https:\/\/api\.clay\.com\/v\d+\/sources\/webhook.*$/;

export const ALPHANUMERIC_WITH_HYPHEN_UNDERSCORE_SPACE_REGEX =
  /^[a-zA-Z0-9]+[a-zA-Z0-9 _-]*[a-zA-Z0-9]+$/;

export const VALID_ASSET_FILENAME = /^[a-zA-Z0-9._-]+$/;
